import LevelBase from './levelBase'
import { Interactive, Exit, Jewel } from '../objects'
// import { PIXEL_TO_TILEMAP_POSITION, PIXEL_NAME } from '../../utils/constants'
import { translate } from '../../utils/localization'
import { SCALE } from '../../utils/constants'
import UI from '../UI'

class Level2 extends LevelBase {
  constructor() {
    super()
    this.name = 'The wise move'
  }

  get id() {
    return this.constructor.key
  }

  async connectToScene(scene) {
    await super.connectToScene(scene)
    
    if(this.unfinished) {
      scene.events.once('levelstart', () => this.showDialog1())
    }

    let light_beam = this.scene.add.image(
      this.scene.cameras.main.width / 2,
      this.scene.cameras.main.height / 2,
      "light_beam"
    );
    light_beam.x = UI.tileToScreen(14);
    light_beam.y = UI.tileToScreen(0);
    light_beam.setOrigin(0, 0);
    light_beam.setScale(SCALE * 2);
    light_beam.scaleX = SCALE * 2.4;
    light_beam.setScrollFactor(1);
    light_beam.depth = 4.5;
    light_beam.alpha = 0.5;

    var particles = scene.add.particles("spark").setScale(SCALE);
    var emitter = particles.createEmitter();
    emitter.setPosition(
      { min: UI.tileToPixels(17), max: UI.tileToPixels(28) },
      { min: UI.tileToPixels(0), max: UI.tileToPixels(15) }
    );
    emitter.setQuantity(5);
    emitter.setFrequency(20000);
    emitter.setAngle({ min: 0, max: 360 });
    emitter.setSpeed(5);
    emitter.setGravityY(0.1);
    emitter.setGravityX(0);
    emitter.setLifespan({ min: 10000, max: 50000 });
    emitter.alpha.onChange(0.5);
  }

  showDialog1() {
    this.scene.events.emit('dialogue:show', {
      participants: ['closeUp_Mary'],
      participantNames: ['Mary'],
      conversation: [
        {
          who: 'closeUp_Mary',
          text: [
            translate('level_2.dialog_1.mary_say_1')
          ],
          options: []
        },
      ]
    })
  }
  showDialog2() {
    this.scene.events.emit('dialogue:show', {
      participants: ['closeUp_Mary'],
      participantNames: ['Mary'],
      conversation: [
        {
          who: 'closeUp_Mary',
          text: [
            translate('level_2.dialog_2.mary_say_1')
          ],
          options: []
        },
      ]
    })
  }

  onInteractWith(el) {
    super.onInteractWith(el)
    
    if(el.isClass(Exit)) {
      this.onComplete()
    }
  }
  onJewelPick(el) {
    super.onJewelPick(el)
    if(el.isClass(Jewel) && this.collectedDiamonds === 1 && this.unfinished) {
      this.showDialog2()
    }
  }
}

Level2.key = 'level_2'
export default Level2
